// extracted by mini-css-extract-plugin
module.exports = {"message":"ConfirmDialog_message__16Zd9","actions":"ConfirmDialog_actions__-453i"};